module.exports = __webpack_public_path__ + "img/07.6b712593.jpg";